@switch (layout()) {
  <!-- Single job: a flat Parameter | Value table. -->
  @case ("single") {
    <div class="xwai-table">
      @if (job(); as j) {
        <div class="table-title" [title]="j.name">{{ j.name }}</div>
      }
      <nz-table
        #paramTable
        nzSize="small"
        nzBordered
        [nzData]="paramRows()"
        [nzScroll]="{ y: '420px' }"
        [nzShowPagination]="false"
        [nzFrontPagination]="false"
      >
        <thead>
          <tr>
            <th nzLeft class="param-col">Parameter</th>
            <th class="value-col">Value</th>
          </tr>
        </thead>
        <tbody>
          @for (row of paramTable.data; track row.name) {
            <tr>
              <td nzLeft class="param-col param-name">{{ row.name | replaceUnderscore }}</td>
              <td class="value-cell">{{ row.value }}</td>
            </tr>
          }
        </tbody>
      </nz-table>
    </div>
  }

  <!-- Matrix: parameters down the side, one column per job.
       Emitted as either "table" or "comparison". -->
  @case ("matrix") {
    <div class="xwai-table">
      <nz-table
        #cmpTable
        nzSize="small"
        nzBordered
        [nzData]="rows()"
        [nzScroll]="{ x: scrollX(), y: '420px' }"
        [nzShowPagination]="false"
        [nzFrontPagination]="false"
      >
        <thead>
          <tr>
            <th nzLeft class="param-col">Parameter</th>
            @for (j of jobs(); track j.id) {
              <th class="job-col" [title]="j.name">{{ j.name }}</th>
            }
          </tr>
        </thead>
        <tbody>
          @for (row of cmpTable.data; track row.name) {
            <tr>
              <td nzLeft class="param-col param-name">{{ row.name | replaceUnderscore }}</td>
              @for (j of jobs(); track j.id) {
                <td class="value-cell" [nzEllipsis]="true">{{ cell(row, j.id) }}</td>
              }
            </tr>
          }
        </tbody>
      </nz-table>
    </div>
  }


  <!-- Unknown table type: show the raw payload so nothing is silently dropped. -->
  @default {
    <pre class="xwai-table-unknown">{{ raw() | json }}</pre>
  }
}
